/**
 * Helper class to convert divs into accordions
 * when viewed on mobile
 */
export default class AccordionUtils {

    static initAccordions(root) {
        root.querySelectorAll('[data-accordion]').forEach((element) => {
            const tab = element.querySelector('.tab')
            if(tab) {
                tab.addEventListener('click', AccordionUtils.toggleExpansion);
            }
        });
    }

    static toggleExpansion(e) {
        e.target.classList.toggle('closed');
    }
}